export default __webpack_public_path__ + "static/media/Service102.d359e9b5.jpg";